// import { Button, CheckIcon } from "@fla/components";
// import withGetStartedNotCompleted from "components/HOCs/withGetStartedNotCompleted";
// import { Helmet } from "react-helmet-async";
// import { getRedirectUrl } from "utils";
// function Dashboard() {
//   return (
//     <>
//       <Helmet>
//         <title>SplitWise | Dashboard</title>
//       </Helmet>
//       <article className="w-full h-[calc(100vh-80px)] flex flex-col justify-center">
//         <div className="max-w-sm lg:max-w-3xl space-y-5 mx-auto p-5 md:p-10 rounded-lg -mt-20 flex flex-col items-center">
//           <CheckIcon strokeColor="text-green-600" classes="w-12 h-12" />
//           <h2 className="font-bold text-center capitalize">We got your details</h2>
//           <p className="text-center">Our legal team will call you to get started with the next steps shortly.</p>
//           <Button
//             bgColor="bg-primary"
//             className="w-full py-2.5 mt-10 rounded-lg tracking-wider hover:bg-primary-faded"
//             onClick={() => window.open(getRedirectUrl().website, "_blank")}
//           >
//             Go To Website
//           </Button>
//         </div>
//       </article>
//     </>
//   );
// }
// export default withGetStartedNotCompleted(Dashboard);
import { ConsentOrderIcon } from "@fla/components";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const cards = [
  {
    icon: ConsentOrderIcon,
    title: "Quote",
    description: "Our legal team will call you to get started with the next steps shortly.",
    path: "/get-started"
  },
  {
    icon: ConsentOrderIcon,
    title: "Consent Orders",
    description:
      "Prepare your consent orders with MKI Legal by providing you and your partner’s details, assets & debts.",
    path: "/consent-orders"
  }
];

function Dashboard() {
  return (
    <>
      <Helmet>
        <title>SplitWise | Dashboard</title>
      </Helmet>
      <article className="w-full h-[calc(100vh-80px)] flex flex-col justify-center">
        <div className="max-w-sm lg:max-w-3xl space-y-5 mx-auto p-5 md:p-10 rounded-lg -mt-20 flex flex-col items-center">
          {cards.map((card, idx) => (
            <Link to={card.path} key={idx} className="w-full mt-10 ">
              <div
                className="w-full p-7 rounded-lg hover:bg-primary/[15%] flex bg-white shadow-md border space-x-7"
                // onClick={() => window.open(getRedirectUrl().website, "_blank")}
              >
                <div>
                  <card.icon strokeColor="text-green-600" classes="w-20 h-20" />
                </div>
                <div>
                  <h4> {card.title}</h4>
                  <p>{card.description}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </article>
    </>
  );
}
export default Dashboard;
